export const LinkVariant = {
  Text: 'text',
  Contained: 'contained',
  Outlined: 'outlined',
  // The section-header treatment (SC-1143): a genuinely borderless text link. `Text` is a
  // filled pill despite its name, so it could not serve the "title left / link top-right"
  // row the built-in components now render.
  Bare: 'bare',
} as const;
export type LinkVariant = (typeof LinkVariant)[keyof typeof LinkVariant];

export const LinkSize = {
  sm: 'sm',
  m: 'm',
  lg: 'lg',
  fullWidth: 'fullWidth',
} as const;
export type LinkSize = (typeof LinkSize)[keyof typeof LinkSize];

export type LinkFormData = {
  url: string;
  label: string;
  openInNewTab: boolean;
  variant: LinkVariant;
  size: LinkSize;
};

export type AnchorLinkProps = {
  href: string;
  children: string;
};
